"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupPaymentMethodContext = void 0;
var SetupPaymentMethodContext;
(function (SetupPaymentMethodContext) {
    SetupPaymentMethodContext["TEAM"] = "team";
    SetupPaymentMethodContext["USER"] = "user";
})(SetupPaymentMethodContext || (exports.SetupPaymentMethodContext = SetupPaymentMethodContext = {}));
